var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="col-6 container--left"> ';
 indicators_left.forEach(function (i) { 
__p+=' <div class="indicator-item"> <h3> <a href="'+
((__t=( i.baseurl ))==null?'':__t)+
'/indicators/'+
((__t=( i.indicator.toLowerCase() ))==null?'':__t)+
'">'+
((__t=( i.name ))==null?'':__t)+
'</a> </h3> ';
 i.text.forEach(function (t) { 
__p+=' <p>'+
((__t=( t ))==null?'':__t)+
'</p> ';
 }); 
__p+=' </div> ';
 }); 
__p+=' </div> <div class="col-6 container--right"> ';
 indicators_right.forEach(function (i) { 
__p+=' <div class="indicator-item"> <h3> <a href="'+
((__t=( i.baseurl ))==null?'':__t)+
'/indicators/'+
((__t=( i.indicator.toLowerCase() ))==null?'':__t)+
'">'+
((__t=( i.name ))==null?'':__t)+
'</a> </h3> ';
 i.text.forEach(function (t) { 
__p+=' <p>'+
((__t=( t ))==null?'':__t)+
'</p> ';
 }); 
__p+=' </div> ';
 }); 
__p+=' </div>';
}
return __p;
};
